export default __webpack_public_path__ + "static/media/empty_star.51ac6047.svg";